export default "__VITE_ASSET__45MnSIt8__"